import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=77813882&scoped=true&"
import script from "./public-header.vue?vue&type=script&lang=js&"
export * from "./public-header.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77813882",
  null
  
)

export default component.exports